"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDocumentMetaSchema = void 0;
var updateDocumentMetaSchema = function (sortedSchema, revisions) {
    var columnKeys = sortedSchema.reduce(function (acc, item) {
        var _a;
        var id = (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : '';
        acc[id] = item.name;
        return acc;
    }, {});
    var mappedColumns = revisions.map(function (document) {
        var _a;
        var _b, _c, _d, _e;
        return (_a = {},
            _a[Object.keys(columnKeys)[0]] = document.name,
            _a[Object.keys(columnKeys)[1]] = (_b = document.meta) === null || _b === void 0 ? void 0 : _b.reliablePartnerStatus,
            _a[Object.keys(columnKeys)[2]] = (_c = document.meta) === null || _c === void 0 ? void 0 : _c.created_at,
            _a[Object.keys(columnKeys)[3]] = "".concat((_d = document.author) === null || _d === void 0 ? void 0 : _d.firstName, " ").concat((_e = document.author) === null || _e === void 0 ? void 0 : _e.lastName),
            _a);
    });
    var updatedDocuments = revisions.map(function (document, index) {
        document.customMeta = mappedColumns[index];
        return document;
    });
    return updatedDocuments;
};
exports.updateDocumentMetaSchema = updateDocumentMetaSchema;
